import { Tabs as AntTabs } from 'antd';
import css from './tabs.module.scss';
import Image from '@/components/UI/Image';

export default function Tabs({ data, active, tabEdit = false, config = { disabled: false, pageType: null, isShowContent: false }, ...rest }: any) {
    const { TabPane } = AntTabs;
    const classList = [css.efTabs];
    const props = { ...rest };
    if (rest.className) {
        classList.push(rest.className);
        props.className = classList;
    }

    return (
        <AntTabs {...props}>
            {data?.length &&
                data?.map((item: any) => (
                    <TabPane
                        key={item.key}
                        tab={
                            tabEdit ? (
                                <div className="tabsItems">
                                    <span>
                                        <Image src={item.key == active ? item.hicons : item.icons} width={60} height={60} alt={item.text}></Image>
                                    </span>
                                    <p> {item.text}</p>
                                </div>
                            ) : (
                                item.text
                            )
                        }
                        disabled={config.disabled}
                    >
                        {config.pageType == 'policy' && <h3>{item.text}</h3>}
                        {config.isShowContent && <div dangerouslySetInnerHTML={{ __html: item.value }} style={{ color: '#35404e' }}></div>}
                    </TabPane>
                ))}
        </AntTabs>
    );
}
